"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoLightIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("./withSVGIcon");
var Icon = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1 : _b;
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("path", { d: "M11.3288 18H12.6697V9.27273H11.3288V18ZM12.0107 7.81818C12.5334 7.81818 12.9652 7.40909 12.9652 6.90909C12.9652 6.40909 12.5334 6 12.0107 6C11.4879 6 11.0561 6.40909 11.0561 6.90909C11.0561 7.40909 11.4879 7.81818 12.0107 7.81818Z", fill: "black" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "12", cy: "12", r: "11.25", stroke: "black", strokeWidth: strokeWidth }, void 0)] }, void 0));
};
exports.InfoLightIcon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 24 24' });
//# sourceMappingURL=InfoLightIcon.js.map